import { ThemeEvents, VariantUpdateEvent } from '@theme/events';
import { morph } from '@theme/morph';

/**
 * 店舗在庫ブロックをバリアント切替に追従させる。
 *
 * PDP の variant-picker はセクション全体を morph せず、差し替え済みの HTML を
 * `variantUpdate` イベントに載せて投げるだけなので、各ブロックが自分で拾う。
 * assets/product-inventory.js と同じ形。
 */
class ProductStoreInventory extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(ThemeEvents.variantUpdate, this.updateStoreInventory);
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(ThemeEvents.variantUpdate, this.updateStoreInventory);
  }

  /**
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updateStoreInventory = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const newStoreInventory = event.detail.data.html.querySelector('product-store-inventory');

    // 器は在庫データが無いバリアントでも描画されるので、見つからないのは想定外。
    // その場合に何もしないと前のバリアントの在庫が残るため、中身を空にする。
    if (!newStoreInventory) {
      this.replaceChildren();
      return;
    }

    // モーダル表示のとき、開いたままバリアントを切り替えると morph が `open` 属性を
    // 落として中身だけ差し替わる（＝在庫は更新されたのにモーダルが消える）。開いていた
    // ことを覚えておいて開き直す。
    const wasOpen = this.querySelector('dialog')?.open === true;

    morph(this, newStoreInventory, { childrenOnly: true });

    if (!wasOpen) return;

    const dialog = this.querySelector('dialog');
    if (dialog instanceof HTMLDialogElement && !dialog.open) dialog.showModal();
  };
}

if (!customElements.get('product-store-inventory')) {
  customElements.define('product-store-inventory', ProductStoreInventory);
}
